/**
 * The function checks if an item is a valid response from an API
 * @param value The item you want to check if it is a valid
 * @returns True if the response is Valid, False if it isn't
 */
export const isValidResponse = async (value: any) => {
    return value !== "" && value !== "null" && value !== undefined && value !== null && value !== "undefined";
};

/**
 * Allows Nav to utilize a Consumer Passed in Router Function
 * @param event The Click Event
 * @param clickHandler The Function the Consumer wishes to be called
 * @param path The Path that the Nav is Linking to
 */
export const handleClick = async (event: Event, clickHandler: Function, path: string) => {
    if (clickHandler) {
        let customPath = path;
        if (customPath.includes(window.location.origin)) {
            customPath = customPath.replace(window.location.origin, "");
            event.preventDefault();
            clickHandler(customPath);
        }
    }
};

/**
 * Capitalizes the first letter of a string
 * @param str The input string to capitalize
 * @returns String with first letter capitalized
 */
export const capitalizeBrandPaths = (str: string): string => {
    if (str === "gmc") {
        return str.toUpperCase();
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 *
 * @param navBarData The data of the nav to be rendered
 * @returns Object containing the currentDepartment and the modified Nav Data
 */
export const updateLiveLocationHelper = async (navBarData: Object) => {
    let navBarDataModified = navBarData;
    let currentDepartment = "";
    let entered = false;
    const sclpRegex = /\/categories\/[^\/]+$/;
    const clpRegex = /\/categories(\?.*)?$/;
    const plpRegex = /\/categories\/[^\/]+\/[^\/]+(\?.*)?$/;

    for (const departments in navBarDataModified) {
        for (const columnIndex in navBarDataModified[departments]["columns"]) {
            for (const categoryIndex in navBarDataModified[departments]["columns"][columnIndex]) {
                if (navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2].length) {
                    if (navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][0] === null) {
                        if (
                            window.location.href.includes(
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][1]
                            ) &&
                            window.location.href.includes("categories")
                        ) {
                            // We are on an CLP Page
                            if (
                                clpRegex.test(window.location.href) &&
                                clpRegex.test(navBarDataModified[departments]["columns"][columnIndex][categoryIndex][1])
                            ) {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = true;
                            } else if (
                                sclpRegex.test(window.location.href) &&
                                sclpRegex.test(
                                    navBarDataModified[departments]["columns"][columnIndex][categoryIndex][1]
                                ) &&
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][1].includes(
                                    window.location.pathname
                                )
                            ) {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = true;
                            } else if (
                                plpRegex.test(window.location.href) &&
                                plpRegex.test(
                                    navBarDataModified[departments]["columns"][columnIndex][categoryIndex][1]
                                ) &&
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][1].includes(
                                    window.location.pathname
                                )
                            ) {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = true;
                            } else {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = false;
                            }

                            currentDepartment = departments;
                        } else {
                            navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = false;
                        }
                    } else {
                        if (navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][0] === true) {
                            // Exact Required
                            const itemLength =
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2].length;

                            for (let i = 1; i < itemLength; i++) {
                                if (
                                    window.location.href ===
                                    navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][i]
                                ) {
                                    entered = true;
                                    navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = true;
                                    currentDepartment = departments;
                                }
                            }
                            if (!entered) {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = false;
                                if (
                                    navBarDataModified[departments]["columns"][columnIndex][
                                        categoryIndex
                                    ][2][1].includes(window.location.host)
                                ) {
                                    currentDepartment = departments;
                                }
                            }
                        } else {
                            // All Fields Required
                            const itemLength =
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2].length;
                            for (let i = 1; i < itemLength; i++) {
                                if (
                                    window.location.href.includes(
                                        navBarDataModified[departments]["columns"][columnIndex][categoryIndex][2][i]
                                    )
                                ) {
                                } else {
                                    entered = true;
                                    navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = false;
                                }
                            }
                            if (entered) {
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = false;
                            } else {
                                currentDepartment = departments;
                                navBarDataModified[departments]["columns"][columnIndex][categoryIndex][3] = true;
                            }
                            entered = false;
                        }
                    }
                }
            }
        }
    }

    return { currentDepartment: currentDepartment, navBarData: navBarDataModified };
};
